var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapAutocomplete',{ref:"GmapAutocomplete",staticClass:"ivu-input",attrs:{"readonly":_vm.readonly,"placeholder":_vm.$t('Location ( Google search )')},on:{"place_changed":_vm.locationSearched}})}
var staticRenderFns = []

export { render, staticRenderFns }